import React from 'react';
import { Award as CustomerAdminIcon } from 'lucide-react';

import classNames from 'classnames';

import { UserType } from 'src/shared/types';
import styles from './UserDetails.module.scss';
import UserTypeTag from '../user-type-tag/UserTypeTag';

type UserDetailsProps = {
    firstName: string;
    lastName: string;
    email: string;
    status: string;
    phone?: string;
    userType?: UserType;
    isCustomerAdmin?: boolean;
    contactInfoClass?: string;
    isAssignedToOrganisation?: boolean;
};

const UserDetails = ({ firstName, lastName, email, status, phone, userType, isCustomerAdmin, contactInfoClass }: UserDetailsProps) => {
    const userNameClass = classNames(styles.name, styles['name' + status]);

    const contactSectionClass = classNames(styles.contact, styles['contact' + status], contactInfoClass);

    return (
        <div className={styles.userDetails}>
            <div className={styles.avatar}>{`${firstName[0]}${lastName[0]}`}</div>
            <div className={styles.info}>
                <div className={userNameClass}>{`${firstName} ${lastName}`}</div>
                <div className={contactSectionClass} data-testid='user-management-user-detail-email'>
                    {email}
                </div>
                {phone && <div className={contactSectionClass}>{phone}</div>}
                {(userType || isCustomerAdmin) && (
                    <div className={styles.icons}>
                        {userType && <UserTypeTag userType={userType} />}
                        {isCustomerAdmin && (
                            <div className={styles.adminIcon}>
                                <CustomerAdminIcon className={styles.customerAdminLogo} /> Admin
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default UserDetails;
